import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import NavbarHome from "../Navbar/NavbarHome";
import "react-datepicker/dist/react-datepicker.css";
import "../../scss/bill.scss";
import "../../scss/FoodBeverage.scss";
import "../../scss/filter.scss";
import axios from "axios";
import BillShowTable from "./Table/BillShowTable";
import ReactSidebar from "../ReactSidebar";
import SelectSearchInput from "../SelectSearch";
import Footer from "../Footer";
import Barchart from "./Table/Barchart";
// import { toast } from "react-toastify";
// import { Modal } from "react-bootstrap";

const Bill = () => {
  let url = process.env.REACT_APP_BASE_URL;
  const today = new Date().toISOString().split('T')[0];
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [selectedOutlet, setSelectedOutlet] = useState("");
  const [token, setToken] = useState("");
  const [order, setOrder] = useState([]);
  const [isOrder, setIsOrder] = useState(true);
  const [food, setFood] = useState([]);
  const [beverage, setBeverage] = useState([]);
  const [beverageGroup, setBeverageGroup] = useState([]);
  const [foodGroup, setFoodGroup] = useState([]);
  const [FoodBeverageSum, setFoodBeverageSum] = useState([]);
  const [totalInfo, setTotalInfo] = useState({});
  const [error, setError] = useState(false);
  const [show, setShow] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState({});
  const [dineinTabs, setDineinTabs] = useState({});
  const [splitDetails, setSplitDetails] = useState({});
  const [arrow, setArrow] = useState(false);
  const [billno, setBillno] = useState("");
  const [FoodSale, setFoodSale] = useState([]);
  const [BeverageSale, setBeverageSale] = useState([]);
  // const [showModal, setShowModal] = useState(false);
  // const [selectedFile, setSelectedFile] = useState(null);
  // const [preview, setPreview] = useState(null);
  // const [isUploading, setIsUploading] = useState(false);

  // const handleCloseModal = () => {
  //   setShowModal(false);
  //   setSelectedFile(null);
  //   setPreview(null);
  // };

  const toggleArrow = () => {
    setArrow(!arrow);
  };

  let navigate = useNavigate();

  useEffect(() => {
    let tokenCheck = sessionStorage.getItem("token");
    let typeCheck = sessionStorage.getItem("type")

    if (tokenCheck === null && typeCheck === 'kitchen') {
      navigate("/");
    } else {
      setToken(sessionStorage.getItem("token"));
    }
    setSelectedOutlet(sessionStorage.getItem("outlet"));
  }, [navigate]);

  const fetchSalesHistory = async () => {
    try {
      const { data } = await axios.post(`${url}/saleshistory`, {
        outlet: selectedOutlet,
        dateStart: startDate,
        dateEnd: endDate,
        token,
      });

      setError(false);
      setTotalInfo(data);
      setOrder(data.orderDetails);
      setFood(data.itemDetails.food);
      setBeverage(data.itemDetails.beverage);
      setFoodBeverageSum(data.itemDetails.itemSum);
      setBeverageGroup(data.itemDetails.beverageGroup);
      setFoodGroup(data.itemDetails.foodGroup);
      setShow(true);

      return data;
    } catch (err) {
      setError(true);
      console.log(err);
      throw err;
    }
  };

  const fetchSummaryReport = async () => {
    try {
      const { data } = await axios.post(`${url}/summaryreport`, {
        outlet: selectedOutlet,
        dateStart: startDate,
        dateEnd: endDate,
        token,
      });

      setSplitDetails(data.splitDetails);
      setDineinTabs(data);
      setPaymentStatus(data.paymentStats);
      setFoodSale(data.FoodSale);
      setBeverageSale(data.BeverageSale);

      return data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  };

  useEffect(() => {
    if (!selectedOutlet) return;

    const loadData = async () => {
      await Promise.allSettled([
        fetchSalesHistory(),
        fetchSummaryReport(),
      ]);

      setShow(true);
    };

    loadData();
  }, [selectedOutlet, token]);

  const viewBill = async () => {
    if (!selectedOutlet) return;

    setIsOrder(true);

    await Promise.allSettled([
      fetchSalesHistory(),
      fetchSummaryReport(),
    ]);

    setShow(true);
  };

  const [billNumber, setBillNumber] = useState([]);
  const [startBillNum, setStartBillNumber] = useState("");
  const [endBillNum, setEndBillNumber] = useState("");

  useEffect(() => {
    if (order.length > 0) {
      const billNumbers = order.map(item => item.bill_no);
      setBillNumber(billNumbers);
      setStartBillNumber(billNumbers[0]);
      setEndBillNumber(billNumbers[billNumbers.length - 1]);
    }
  }, [order]);

  const handleBillNumber = (e) => {
    setBillno(e.target.value);
    setIsOrder(false);
  };

  useEffect(() => {
    if (billno === "") {
      axios
        .post(`${url}/saleshistory`, {
          outlet: `${selectedOutlet}`,
          dateStart: startDate,
          dateEnd: endDate,
          token: token,
        })
        .then((response) => {
          setIsOrder(true);
          setShow(true);
          setError(false);
          setTotalInfo(response.data);
          setOrder(response.data.orderDetails);
          setFood(response.data.itemDetails.food);
          setBeverage(response.data.itemDetails.beverage);
          setFoodBeverageSum(response.data.itemDetails.itemSum);
          setBeverageGroup(response.data.itemDetails.beverageGroup);
          setFoodGroup(response.data.itemDetails.foodGroup);
        })
        .catch((error) => {
          setError(true);
        });
    }
    if (billno) {
      axios
        .post(`${url}/billsearch`, {
          outlet: `${selectedOutlet}`,
          billno: `${billno}`,
          token: token,
        })
        .then((response) => {
          setIsOrder(false);
          setOrder(response.data);
          setShow(true);
        })
        .catch((error) => {
          // console.log(error)
        });
    }
  }, [billno]);

  // const handleFileChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setSelectedFile(file);
  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       setPreview(reader.result);
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // };

  // const handleUploadImage = async () => {
  //   if (!selectedFile) {
  //     toast.error('Please select a file first');
  //     return;
  //   }

  //   setIsUploading(true);

  //   try {
  //     const formData = new FormData();
  //     formData.append('logo', selectedFile);
  //     formData.append('token', token);
  //     formData.append('outlet', selectedOutlet);

  //     await axios.post(`${url}/upload_outlet_logo`, formData, {
  //       headers: {
  //         'Content-Type': 'multipart/form-data'
  //       }
  //     });

  //     toast.success('Logo updated successfully');
  //     handleCloseModal();
  //   } catch (error) {
  //     toast.error('Error uploading logo');
  //     console.log("Logo upload error", error);
  //   } finally {
  //     setIsUploading(false);
  //   }
  // };

  return (
    <div>
      <NavbarHome arrow={arrow} />

      <div className="sidebar-container relative">
        {/* <div className="flex gap-3 top-4 right-4 absolute">
          <button
            onClick={() => setShowModal(true)}
            className="px-3 py-2 rounded-sm font-medium bg-purple-100 text-purple-800 hover:bg-purple-200 hover:shadow-md text-xs"
          >
            Upload Logo
          </button>

          <button
            onClick={() => navigate('/franchisesalesdetails')}
            className="px-3 py-2 rounded-sm font-medium bg-blue-100 text-blue-800 hover:bg-blue-200 hover:shadow-md text-xs"
          >
            View Franchise Sales
          </button>
        </div> */}

        <ReactSidebar
          dineinTabs={dineinTabs}
          paymentStatus={paymentStatus}
          splitDetails={splitDetails}
          toggleArrow={toggleArrow}
          arrow={arrow}
          startBillNum={startBillNum}
          endBillNum={endBillNum}
          FoodBeverageSum={FoodBeverageSum}
        />

        <div className={"container main-content my-3"}>
          {dineinTabs && <Barchart dineinTabs={dineinTabs} />}

          <div className="select-options z-50">
            <div className="date-picker-outlet">
              <div className="flex flex-col">
                <label>Start Date:</label>
                <input
                  type="date"
                  className="border p-1 rounded"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </div>
              <div className="enter-bil-no">
                <div>
                  <h6>{selectedOutlet}</h6>
                  <SelectSearchInput
                    token={token}
                    setToken={setToken}
                    setSelectedOutlet={setSelectedOutlet}
                    selectedOutlet={selectedOutlet}
                  />
                </div>
                <div>
                  <input
                    type="text"
                    placeholder="Search by bill no."
                    className="bill-number"
                    onChange={handleBillNumber}
                  />
                </div>
              </div>
              <div className="flex flex-col">
                <label>End Date:</label>
                <input
                  type="date"
                  className="border p-1 rounded"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>
              <div className="btn-search-view">
                <button onClick={viewBill} className="btn-search">
                  View
                </button>
              </div>
            </div>

            <div className="date-picker-outlet-sm">
              <div>
                <h6>{selectedOutlet}</h6>
                <SelectSearchInput
                  token={token}
                  setToken={setToken}
                  setSelectedOutlet={setSelectedOutlet}
                  selectedOutlet={selectedOutlet}
                />
              </div>

              <div className="start-date">
                <label>Start Date:</label>
                <input
                  type="date"
                  className="border p-1 rounded"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </div>
              <div className="end-date">
                <label>End Date:</label>
                <input
                  type="date"
                  className="border p-1 rounded"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>
              <div>
                <label>Bill No:</label>
                <div>
                  <input
                    type="number"
                    placeholder="Search by bill no."
                    className="bill-number"
                    onChange={handleBillNumber}
                  />
                </div>
              </div>
              <div className="btn-search-view">
                <button onClick={viewBill} className="btn-search">
                  View
                </button>
              </div>
            </div>
          </div>

          {show && (
            <BillShowTable
              order={order}
              isOrder={isOrder}
              totalInfo={totalInfo}
              selected={selectedOutlet}
              token={token}
              food={food}
              foodGroup={foodGroup}
              beverage={beverage}
              beverageGroup={beverageGroup}
              FoodBeverageSum={FoodBeverageSum}
              FoodSale={FoodSale}
              BeverageSale={BeverageSale}
              startDate={startDate}
              endDate={endDate}
              url={url}
              setBillno={setBillno}
            />
          )}
        </div>
      </div>

      {/* <Modal show={showModal} onHide={handleCloseModal} size="md">
        <Modal.Header closeButton>
          <Modal.Title>Upload Logo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <div>
              <label htmlFor="imageUpload" className="form-label">
                Select Image
              </label>
              <input
                type="file"
                className="form-control"
                id="imageUpload"
                accept="image/*"
                onChange={handleFileChange}
              />
            </div>
          </div>

          <div className="mb-3">
            <div>
              <label htmlFor="imageUpload" className="form-label">
                Selected Outlet
              </label>
              <input
                type="text"
                className="form-control"
                value={selectedOutlet}
                disabled
              />
            </div>
          </div>

          {preview && (
            <div className="mt-3">
              <h6>Preview:</h6>
              <img
                src={preview}
                alt="Preview"
                className="img-fluid mt-2"
                style={{ maxHeight: '200px' }}
              />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={handleCloseModal}>
            Close
          </button>
          <button
            className="btn btn-primary"
            onClick={handleUploadImage}
            disabled={!selectedFile || isUploading}
          >
            {isUploading ? 'Uploading...' : 'Upload'}
          </button>
        </Modal.Footer>
      </Modal> */}
      <Footer />
    </div>
  );
};

export default Bill;
